export default {
  1: 'error.emailOrPasswordWrong',
  2: 'error.accountExistsButMenteeRoleIsUnexpected',
  3: 'error.accountAlreadyExists',
  4: 'error.accountAlreadyExistsButIsntACompany',
  5: 'error.wrongPassword',
  6: 'error.inactiveAccount',
}



// WEBPACK FOOTER //
// ./src/project-utils/error-code-map.ts